<template>
	<div class="ma-4 invoice-table-shell portal-compact-list-shell">
		<div class="mt-4">
			<v-data-table
				class="portal-compact-table"
				:headers="headers"
				:items="filteredResults"
				sort-by="dateSent"
				:sort-desc="true"
				style="cursor: pointer"
				:hide-default-footer="true"
				:disable-pagination="true"
        :mobile-breakpoint="200"
				@click:row="openInvoice($event)"
			>
				<template v-slot:item.dateSent="{ item }">
					<span
						v-if="item.dateSent"
						class="portal-cell-truncate portal-cell-muted"
						:title="DateTime.fromISO(item.dateSent).toLocaleString(DateTime.DATE_MED)"
					>
						{{ DateTime.fromISO(item.dateSent).toLocaleString(DateTime.DATE_MED) }}
					</span>
				</template>

				<template v-slot:item.dateDue="{ item }">
					<span
						v-if="item.dateDue"
						class="portal-cell-truncate portal-cell-muted"
						:title="DateTime.fromISO(item.dateDue).toLocaleString(DateTime.DATE_MED)"
					>
						{{ DateTime.fromISO(item.dateDue).toLocaleString(DateTime.DATE_MED) }}
					</span>
				</template>

				<template v-slot:item.invoiceNumberFormatted="{ item }">
					<span class="portal-cell-truncate portal-cell-primary" :title="item.invoiceNumberFormatted">
						{{ item.invoiceNumberFormatted }}
					</span>
				</template>

				<template v-slot:item.total="{ item }">
					<div v-if="item.total" class="portal-cell-truncate">
						<div>{{ $formatters.dollars(item.total ? item.total : 0, true, true, item.currency) }}</div>
						<div v-if="item.refundTotal" class="font-11 portal-cell-muted">
							{{ $t('invoices.refunded-amount', { amount: $formatters.dollars(item.refundTotal, true, true, item.currency) }) }}
						</div>
					</div>
				</template>

				<template v-slot:item.status="{ item }">
					<portal-status-pill
						:color="`var(${item.statusDetail.color})`"
						:background="`var(${item.statusDetail.background})`"
					>
						{{ item.statusDetail.label }}
					</portal-status-pill>
				</template>

				<template v-slot:item.id="{ item }">
          <v-btn
						v-if="item.statusDetail.payable && item.amountDue > 0 && item.payOnlineUrl && item.allowOnlinePayment"
						elevation="0"
						color="success"
						small
						@click.stop="goToPaymentPage(item.payOnlineUrl)"
						><span class="font-12 brand-bold">{{ $t('invoices.pay-now') }}</span></v-btn
					>
				</template>

				<template v-slot:no-data>
					{{ $t('invoices.no-invoice-record') }}
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
	import { DateTime } from 'luxon';
	import InvoiceDetails from '@/modules/invoices/InvoiceDetails';

	export default {
		name: 'InvoiceTableAndChart',
		components: {},
		props: ['filter', 'invoices'],

		data() {
			return {
				DateTime: DateTime,
			};
		},

		mounted() {},

		methods: {
			openInvoice: function(invoice) {
				let binding = {
					invoiceId: invoice.id,
				};
				this.$store.state.globalModalController
					.openModal(InvoiceDetails, binding, true, false, 'document-lightbox')
					.then(() => this.$emit('refresh'));
			},

			goToPaymentPage: function(payOnlineUrl) {
				const token = new URL(payOnlineUrl).searchParams.get('token');
				window.open(window.location.origin + '/payment?token=' + token, '_blank');
			},

			formatDate(date) {
				return DateTime.fromISO(date).toFormat('MMM dd, YYYY');
			},

		},

		computed: {
			headers: function() {
				return [
					{
						text: this.$t('invoices.list.invoice-number'),
						value: 'invoiceNumberFormatted',
						class: 'portal-list-grow',
						cellClass: 'portal-list-grow',
					},
					{
						text: this.$t('invoices.list.issued'),
						value: 'dateSent',
						width: 132,
						class: 'portal-list-priority-low',
						cellClass: 'portal-list-priority-low',
					},
					{
						text: this.$t('global.due'),
						value: 'dateDue',
						width: 132,
						class: 'portal-list-priority-medium',
						cellClass: 'portal-list-priority-medium',
					},
					{
						text: this.$t('invoices.list.total'),
						value: 'total',
						width: 120,
						class: 'portal-list-priority-compact',
						cellClass: 'portal-list-priority-compact',
					},
					{ text: this.$t('invoices.status.heading'), value: 'status', width: 128 },
					{ text: '', value: 'id', width: 112, sortable: false },
				];
			},

			filteredResults: function() {
				if (!this.filter) {
					return this.invoices;
				}

				let results = [...this.invoices];
				let search = this.filter.toLowerCase();

				return results.filter((i) => {
					if (
						i.invoiceNumberFormatted
							.toString()
							.toLowerCase()
							.includes(search)
					) {
						return true;
					} else if (i.statusDetail.label.toLowerCase().startsWith(search)) {
						return true;
					} else if (i.total.toString().startsWith(search)) {
						return true;
					} else if (
						DateTime.fromISO(i.dateSent)
							.toFormat('DDD')
							.toLowerCase()
							.startsWith(search)
					) {
						return true;
					} else if (
						DateTime.fromISO(i.dateDue)
							.toFormat('DDD')
							.toLowerCase()
							.startsWith(search)
					) {
						return true;
					}

					return false;
				});
			},
		},

		watch: {},
	};
</script>

<style scoped lang="scss">
	.action-menu ::v-deep {
		.primary-action {
			border: 0px !important;
		}
		.menu-activator {
			border: 0px !important;
		}
	}
</style>
